import * as React from "react";
import { PropertyFiltersComponentProps } from "../typings";
import { UitkRadio } from "uitk-react-switch";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { PROPERTY_FILTERS } from "components/flexComponents/PropertyFilters/PropertyFilters";

const RadioButtonTracked = FlexClickTracker(UitkRadio);

export const Radio = (props: PropertyFiltersComponentProps) => {
  const { filterName, option, context, moduleName } = props;
  const [isSelected, setIsSelected] = React.useState(context.isSelected(filterName, option.optionValue!));

  React.useEffect(() => {
    context.addListener(filterName, option.optionValue!, setIsSelected);
  }, []);

  const onChange = () => {
    context.toggleSelection(filterName, option.optionValue!);
  };

  return (
    <RadioButtonTracked
      events="click"
      id={`${filterName}-${option.optionValue}`}
      label={option.label}
      moduleName={PROPERTY_FILTERS}
      rfrr={`${moduleName}.${filterName}.${option.optionValue}.${!isSelected}`}
      value={option.optionValue}
      checked={isSelected}
      onChange={onChange}
      description={option.description}
    />
  );
};
